<template>
    <!-- Modified by Martin - 2026-05-15 -->
    <button
        :class="['lixsa-cancel-btn', { 'lixsa-cancel-btn--disabled': disabled }]"
        :disabled="disabled"
        type="button"
        @click="handleClick"
    >
        <span class="lixsa-cancel-btn__label">{{ label || $t('common.cancel') }}</span>
    </button>
</template>

<script>
export default {
    name: 'LixsaCancelButton',
    props: {
        /** Externally disabled state */
        disabled: {
            type: Boolean,
            default: false,
        },
        /** Optional custom label */
        label: {
            type: String,
            default: '',
        },
    },
    emits: ['click'],
    methods: {
        handleClick(event) {
            if (!this.disabled) {
                this.$emit('click', event);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.lixsa-cancel-btn {
    appearance: none;
    background-color: transparent;
    border: none;
    color: #6551e8; // Primary Lixsa Brand Color
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    min-width: 80px;
    padding: 0 16px;
    margin: 6px 8px;
    border-radius: 8px;
    cursor: pointer;
    transition:
        background-color 0.2s ease,
        opacity 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover:not(.lixsa-cancel-btn--disabled) {
        background-color: rgba(101, 81, 232, 0.08); // Very light primary color for hover
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(101, 81, 232, 0.2); // Subtle focus ring
    }

    &--disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &__label {
        line-height: 1;
    }
}
</style>
